function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
import FormHelperText from "@mui/material/FormHelperText";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
//Limitless imports
import TimerLabel from "../timer-label/TimerLabel";
const useStyles = makeStyles(theme => ({
  textInput: {
    fontSize: "0.8125rem"
  },
  mandatory: {
    color: theme.palette.error.main,
    display: "inline-flex",
    position: "relative",
    bottom: 4,
    marginLeft: 3
  },
  helperText: {
    minHeight: 19
  },
  largeHelperText: {
    minHeight: 38
  },
  disabled: {
    color: theme.palette.action.disabled
  },
  adornedEnd: {
    paddingRight: 0
  }
}));
const ActionInput = ({
  secureData,
  t,
  label,
  isMandatory,
  helperText,
  error,
  largeHelperText,
  background = null,
  showHelperText,
  labelPos,
  labelEllipsis,
  errorLabel = false,
  action,
  value,
  ...rest
}) => {
  const classes = useStyles({
    background
  });
  const [canSubmit, setCanSubmit] = React.useState(true);
  const [timeLeft, setTimeLeft] = React.useState(false);
  let ellipsisCSS = {};
  if (labelEllipsis) {
    ellipsisCSS = {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis"
    };
  }
  const isRtl = document.documentElement.getAttribute("dir") === "rtl";
  React.useEffect(() => {
    const id = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => {
      clearTimeout(id);
    };
  });
  const handleSubmitClick = () => {
    setCanSubmit(false);
    action.onActionClick();
  };
  const calculateTimeLeft = () => {
    const thisDateTime = Math.floor(new Date().getTime() / 1000);
    const expiresAt = secureData.expiresAt;
    const diff = expiresAt - thisDateTime >= 0 ? expiresAt - thisDateTime : 0;
    const seconds = diff > 0 ? Math.floor(diff % 60) : 0;
    return seconds >= 0 ? seconds : 0;
  };
  let inputProps = {};
  if (action) {
    const ActionIcon = action.icon;
    const ActionCompleteIcon = action.complete.icon;
    inputProps = {
      endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end",
        style: {
          height: 44
        }
      }, timeLeft > 0 && canSubmit && !error && !secureData.completed ? /*#__PURE__*/React.createElement(IconButton, {
        onClick: canSubmit && handleSubmitClick,
        id: `${label.toLowerCase()}Icon`,
        disabled: !canSubmit,
        size: "large"
      }, /*#__PURE__*/React.createElement(ActionIcon, {
        className: classes.addIcon
      })) : secureData.completed && /*#__PURE__*/React.createElement(ActionCompleteIcon, {
        color: "secondary",
        style: {
          marginRight: 8
        }
      })),
      classes: {
        adornedEnd: classes.adornedEnd,
        root: classes.textInput
      },
      style: {
        height: 44,
        paddingLeft: 8,
        overflow: "hidden"
      }
    };
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    color: error && errorLabel ? "error" : "textPrimary",
    component: "label",
    style: {
      position: labelPos,
      ...ellipsisCSS
    },
    htmlFor: rest.id,
    className: `${timeLeft === 0 ? classes.disabled : ""}`
  }, t(label), " ", isMandatory && /*#__PURE__*/React.createElement("div", {
    className: classes.mandatory
  }, "*"))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    style: {
      textAlign: isRtl ? "left" : "right"
    }
  }, /*#__PURE__*/React.createElement(TimerLabel, {
    expiry: secureData.expiresAt,
    color: secureData !== null && secureData !== void 0 && secureData.completed ? "secondary" : "error",
    refresh: 1000,
    completed: secureData.completed
  }))), /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, _extends({
    variant: "outlined",
    style: {
      width: "100%"
    },
    InputProps: inputProps,
    value: value,
    autoComplete: "off",
    disabled: timeLeft === 0 || secureData.completed
  }, rest))), showHelperText && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(FormHelperText, {
    className: largeHelperText ? classes.largeHelperText : classes.helperText,
    error: error
  }, t(helperText)))));
};
export default ActionInput;
ActionInput.propTypes = {
  error: PropTypes.bool,
  color: PropTypes.string,
  secureData: PropTypes.object,
  isMandatory: PropTypes.bool,
  label: PropTypes.string,
  helperText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  largeHelperText: PropTypes.bool,
  t: PropTypes.func.isRequired,
  background: PropTypes.string,
  showHelperText: PropTypes.bool,
  labelPos: PropTypes.string,
  labelEllipsis: PropTypes.bool,
  errorLabel: PropTypes.bool,
  placeholder: PropTypes.string,
  action: PropTypes.object,
  value: PropTypes.string
};
ActionInput.defaultProps = {
  isMandatory: false,
  helperText: "",
  error: false,
  color: "secondary",
  largeHelperText: false,
  background: "inherit",
  showHelperText: true,
  labelEllipsis: false,
  labelPos: "relative"
};